/** Enterprise.Data.Values.ListingExposureLevel */
export var ListingExposureLevel;
(function (ListingExposureLevel) {
    ListingExposureLevel[ListingExposureLevel["NoExposure"] = 0] = "NoExposure";
    ListingExposureLevel[ListingExposureLevel["Basic"] = 1] = "Basic";
    ListingExposureLevel[ListingExposureLevel["Silver"] = 2] = "Silver";
    ListingExposureLevel[ListingExposureLevel["Gold"] = 3] = "Gold";
    ListingExposureLevel[ListingExposureLevel["Platinum"] = 4] = "Platinum";
    ListingExposureLevel[ListingExposureLevel["Diamond"] = 5] = "Diamond";
    ListingExposureLevel[ListingExposureLevel["DiamondPlus"] = 6] = "DiamondPlus";
    ListingExposureLevel[ListingExposureLevel["SilverPlus"] = 7] = "SilverPlus";
    ListingExposureLevel[ListingExposureLevel["GoldPlus"] = 8] = "GoldPlus";
    ListingExposureLevel[ListingExposureLevel["PlatinumPlus"] = 9] = "PlatinumPlus";
    ListingExposureLevel[ListingExposureLevel["DiamondSpotlight"] = 10] = "DiamondSpotlight";
})(ListingExposureLevel || (ListingExposureLevel = {}));
/** Enterprise.Data.Values.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["Unknown"] = 0] = "Unknown";
    ListingType[ListingType["ApartmentCommunity"] = 1] = "ApartmentCommunity";
    ListingType[ListingType["ApartmentUnitForRent"] = 2] = "ApartmentUnitForRent";
    ListingType[ListingType["SingleFamilyHome"] = 3] = "SingleFamilyHome";
    /** @deprecated Deprecated. Renamed to ResidentialCommunity. */
    ListingType[ListingType["RoomForRent"] = 4] = "RoomForRent";
    ListingType[ListingType["ResidentialCommunity"] = 4] = "ResidentialCommunity";
    ListingType[ListingType["Townhome"] = 5] = "Townhome";
    ListingType[ListingType["ApartmentCondo"] = 6] = "ApartmentCondo";
    ListingType[ListingType["ResidentialCondo"] = 7] = "ResidentialCondo";
    ListingType[ListingType["Hotel"] = 8] = "Hotel";
    ListingType[ListingType["PropertyForSale"] = 9] = "PropertyForSale";
    ListingType[ListingType["ResidentialPropertyForSale"] = 10] = "ResidentialPropertyForSale";
    ListingType[ListingType["CondoForSale"] = 11] = "CondoForSale";
    ListingType[ListingType["LandForSale"] = 12] = "LandForSale";
    ListingType[ListingType["CommercialPortfolioForSale"] = 13] = "CommercialPortfolioForSale";
    ListingType[ListingType["PropertyDirectSpaceForLease"] = 14] = "PropertyDirectSpaceForLease";
    ListingType[ListingType["ConsolidatedCondoForSaleListing"] = 15] = "ConsolidatedCondoForSaleListing";
    ListingType[ListingType["BuildingParkDirectSpaceLease"] = 16] = "BuildingParkDirectSpaceLease";
    ListingType[ListingType["ShoppingCenterDirectSpaceForLease"] = 17] = "ShoppingCenterDirectSpaceForLease";
    ListingType[ListingType["LandDirectForLease"] = 18] = "LandDirectForLease";
    ListingType[ListingType["CommercialSublease"] = 19] = "CommercialSublease";
    ListingType[ListingType["CommercialLeaseAssignment"] = 20] = "CommercialLeaseAssignment";
    ListingType[ListingType["PropertyCoworking"] = 21] = "PropertyCoworking";
    ListingType[ListingType["PropertyForAuction"] = 22] = "PropertyForAuction";
    ListingType[ListingType["LandForAuction"] = 23] = "LandForAuction";
    ListingType[ListingType["CondoForAuction"] = 24] = "CondoForAuction";
    ListingType[ListingType["LoanForAuction"] = 25] = "LoanForAuction";
    ListingType[ListingType["CommercialPortfolioForAuction"] = 26] = "CommercialPortfolioForAuction";
    ListingType[ListingType["DisconnectedForSale"] = 27] = "DisconnectedForSale";
    ListingType[ListingType["DisconnectedSpaceForLease"] = 28] = "DisconnectedSpaceForLease";
})(ListingType || (ListingType = {}));
/** Enterprise.Data.Values.ListingStatus */
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus[ListingStatus["Unknown"] = 0] = "Unknown";
    ListingStatus[ListingStatus["Active"] = 1] = "Active";
    ListingStatus[ListingStatus["Pending"] = 2] = "Pending";
    ListingStatus[ListingStatus["OffMarket"] = 3] = "OffMarket";
    ListingStatus[ListingStatus["Terminate"] = 4] = "Terminate";
    ListingStatus[ListingStatus["SubscriptionHold"] = 5] = "SubscriptionHold";
    ListingStatus[ListingStatus["Unpublished"] = 6] = "Unpublished";
    ListingStatus[ListingStatus["AwaitingVerification"] = 7] = "AwaitingVerification";
    ListingStatus[ListingStatus["UserDeleted"] = 8] = "UserDeleted";
    ListingStatus[ListingStatus["Upsell"] = 9] = "Upsell";
    ListingStatus[ListingStatus["Confidential"] = 10] = "Confidential";
    ListingStatus[ListingStatus["Introduction"] = 11] = "Introduction";
    ListingStatus[ListingStatus["Migrated"] = 12] = "Migrated";
    ListingStatus[ListingStatus["Draft"] = 13] = "Draft";
})(ListingStatus || (ListingStatus = {}));
/** Enterprise.Data.Values.PropertyType */
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["Unknown"] = 0] = "Unknown";
    PropertyType[PropertyType["Hospitality"] = 1] = "Hospitality";
    PropertyType[PropertyType["Industrial"] = 2] = "Industrial";
    PropertyType[PropertyType["Land"] = 3] = "Land";
    PropertyType[PropertyType["Office"] = 5] = "Office";
    PropertyType[PropertyType["GeneralRetail"] = 6] = "GeneralRetail";
    PropertyType[PropertyType["Flex"] = 7] = "Flex";
    PropertyType[PropertyType["SportsAndEntertainment"] = 8] = "SportsAndEntertainment";
    PropertyType[PropertyType["MixedUse"] = 9] = "MixedUse";
    PropertyType[PropertyType["Specialty"] = 10] = "Specialty";
    PropertyType[PropertyType["Multifamily"] = 11] = "Multifamily";
    PropertyType[PropertyType["Healthcare"] = 13] = "Healthcare";
    PropertyType[PropertyType["PropertyTypeUnknown"] = 14] = "PropertyTypeUnknown";
    PropertyType[PropertyType["Residential"] = 15] = "Residential";
    PropertyType[PropertyType["Homes"] = 16] = "Homes";
})(PropertyType || (PropertyType = {}));
